import yaml from 'js-yaml';

export async function fetchAndParseYAML(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const text = await response.text();
    const data = yaml.load(text);
    // console.log('Parsed YAML:', data);
    return data;
  } catch (error) {
    console.error('Failed to fetch or parse YAML:', error);
  }
}

